export default {
	defaultProps: {
		disableElevation: true,
		color: 'secondary',
	},
	styleOverrides: {
		root: {
			paddingTop: '8px',
			paddingBottom: '8px',
		},
	},
};
